import styled from 'styled-components';

const StyledHeroShelfzone = styled.div`
  background-color: #000;
  padding: 94px 64px 0;
  height: auto;
  overflow: hidden;
  .slides--shelfzone{
    position: relative;
    width: 100%;
    padding-top: ${ props => props.theme.components_spacing_desk.medium}px;
  }
  .slides--content{
    position: relative;
    width: 100%;
  }
  .single-slide--shelfzone{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
  } 
  .single-slide--shelfzone.current{
    position: relative;
  }
  .col-text--shelfzone{
    color: #fff;
    flex: 0 0 41.67%;
  }

  .col-text--shelfzone img {
    width: 132px;
    opacity: 0;
    transform: scale(0.9);
    filter: blur(15px);
    transition: all 0.5s;
  }
  .current .col-text--shelfzone img {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
    transition: all 1s 0.5s;
  }

  .col-text--shelfzone h4 {
    padding: 24px 0 40px;
    opacity: 0;
    transform: scale(0.9);
    filter: blur(15px);
    transition: all 0.5s;
  }
  .current .col-text--shelfzone h4 {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
    transition: all 1s 0.6s;
  }

  .col-text--shelfzone p {
    opacity: 0;
    transform: scale(0.9);
    filter: blur(15px);
    transition: all 0.5s;
  }
  .current .col-text--shelfzone p {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
    transition: all 1s 0.7s;
  }

  .col-img--shelfzone{
    position: relative;
    flex: 0 0 49%;
  }

  .col-img--shelfzone img {
    width: 140%;
    padding-left: 40px;
    transform: scale(0.9);
    opacity: 0;
    animation: exitSlide 0.5s 1 0s forwards ease-out ;
  }
  .current .col-img--shelfzone img {
    animation: enterSlide 1s 1 0.5s forwards ease-out ;
    transition: none;
  }
  .bullets-wrap--slider{
    position: relative;
    padding: ${ props => props.theme.components_spacing_desk.medium}px 0;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bullets-wrap--slider .bullet-circle{
    width: 12px;
    height: 12px;
    background-color: #fff;
    opacity: .5;
    border-radius: 50%;
    margin: 0 18px;
    cursor: pointer;
    transition: opacity .5s;
  }
  .bullets-wrap--slider .bullet-circle.active{
    opacity: 1;
  }
  @media screen and (max-width: 1439px){
    padding: 94px 40px 0;
    .col-text--shelfzone{
      flex: 0 0 49%;
    }
  }
  @media screen and (max-width: 1023px){
    .slides--shelfzone{
      padding-top: ${ props => props.theme.components_spacing_tablet.medium}px;
    }
    .single-slide--shelfzone{
      flex-flow: column-reverse wrap;
    }
    .col-shelfzone {
      flex: 1 0 100%;
      width: 83.33%;
      text-align: center;
    }
    .col-img--shelfzone img {
      width: 100%;
      margin: 0 auto 40px;
      right: auto;
      padding: 0;
    }
    .col-text--shelfzone img {
      width: 99px;
    }
    .bullets-wrap--slider{
      position: relative;
      padding: ${ props => props.theme.components_spacing_tablet.medium}px 0;
    }
  }
  @media screen and (max-width: 767px){
    padding: 81px 24px 0;
    .slides--shelfzone{
      padding-top: 0px;
    }
    .col-shelfzone {
      width: 100%;
    }
    .col-img--shelfzone img {
      margin: 0 auto 24px;
    }
    .bullets-wrap--slider{
      position: relative;
      padding: ${ props => props.theme.components_spacing_mobile.medium}px 0;
    }
  }
  @keyframes enterSlide {
    0% {
      transform: translateX(10%) scale(1);
      opacity: 0;
    }
    100% {
      transform: translateX(0) scale(1);
      opacity: 1;
    }
  } 
  @keyframes exitSlide {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.9);
      opacity: 0;
    }
  } 
`;

export {
  StyledHeroShelfzone,
};

